import { useEffect } from 'react';

const BASE_TITLE = 'ODO Admin';

// Sets the browser-tab title for the current page. Pass null/undefined while
// a dynamic title is still loading (e.g. the patient name on the patient
// file) - the previous title sticks until the real one is known.
export function usePageTitle(title: string | null | undefined): void {
    useEffect(() => {
        if (title) document.title = `${title} · ${BASE_TITLE}`;
    }, [title]);
}
